import { AfterViewInit, ChangeDetectorRef, Component, OnInit, ViewChild } from '@angular/core';
import { DialogService } from 'src/app/services/dialog.service';
import { StaticDataService } from 'src/app/services/static-data.service';
import { TdoTableV2Component } from 'src/app/tdo-controls/common/tdo-table-v2/tdo-table-v2.component';
import { ConfigurationService } from '../../configuration.service';
import { NotesToFrontService } from 'src/app/services/notes-to-front.service';
import { TdoTableSelectionEvent } from 'src/app/tdo-controls/common/tdo-table-v2/models/tdo-table-selection.event';
import { NotesToFrontAutoFillDetail } from 'src/app/modules/notes/models/notes-to-front-autofill/notes-to-front-autofill-detail.model';
import { EnumValidValueItemModel } from 'src/app/models/enum/enum-valid-value-item.model';
import { ClientLocationDataModel } from 'src/app/models/clients/client-location-data.model';
import { TdoClientConfigurationModel } from 'src/app/models/clients/tdo-client-configuration.model';
import { OfficeLocationsService } from '../../office-locations/office-locations.service';
import { Globals } from 'src/app/globals';
import { OperatoriesService } from '../../operatories/operatories.service';
import { OperatoryDataModel } from 'src/app/models/clients/operatory-data.model';
import { TdoDropdownChange } from 'src/app/tdo-controls/common/tdo-dropdown-v2/models/tdo-dropdown-change';
import NotesToFrontAutoFill from 'src/app/modules/notes/models/notes-to-front-autofill/notes-to-front-autofill.model';
import { CfgNoteToFrontAutoFillDetailOperatories } from 'src/app/modules/notes/models/notes-to-front-autofill/cfg-note-to-front-auto-fill-detail-operatories.model';
import { TdoDropdownV2Component } from 'src/app/tdo-controls/common/tdo-dropdown-v2/tdo-dropdown-v2.component';
import { MatSnackBar } from '@angular/material/snack-bar';



@Component({
  selector: 'app-notes-to-front-scheduling',
  templateUrl: './notes-to-front-scheduling.component.html',
  styleUrls: ['./notes-to-front-scheduling.component.scss']
})
export class NotesToFrontSchedulingComponent implements AfterViewInit, OnInit {
  @ViewChild('autoFillAppointment') autoFillAppointment: TdoTableV2Component;
  @ViewChild('autoFillAppointmentDetail') autoFillAppointmentDetail: TdoTableV2Component;
  @ViewChild('autoFillAppointmentOperatories') autoFillAppointmentOperatories: TdoTableV2Component;
  @ViewChild('availableLocationOperatories') availableLocationOperatories: TdoTableV2Component;
  @ViewChild('locationSelector') locationSelector: TdoDropdownV2Component;


  isLoading: boolean = false;

  clientList: any;
  locations: ClientLocationDataModel[];

  selectedClient: any;
  selectedLocation: ClientLocationDataModel;

  autoFillList: NotesToFrontAutoFill[] = [];
  selectedAutoFillModel: NotesToFrontAutoFill;
  selectedAutoFillDetailModel: NotesToFrontAutoFillDetail;

  nextAppointmentEnums: EnumValidValueItemModel[];
  nextAppointmentLengthEnums: EnumValidValueItemModel[];
  nextAppointmentDateEnums: EnumValidValueItemModel[];

  locationOperatories: OperatoryDataModel[];
  availableOperatories: OperatoryDataModel[];

  constructor(
    private cd: ChangeDetectorRef,
    private locService: OfficeLocationsService,
    private globals: Globals,
    private staticDataService: StaticDataService,
    private notesToFrontService: NotesToFrontService,
    public configurationService: ConfigurationService,
    private dialogService: DialogService,
    private opsService: OperatoriesService,
    private snackBar: MatSnackBar) {
  }

  ngOnInit(): void {
    this.locService.getClients().subscribe(data => {
      this.clientList = data;
      if (this.clientList.length > 0) {
        // Try to locate current users client
        const client = this.clientList.find(p => p.TDOCID.toString() === this.globals.TDOCID);
        if (client) {
          this.selectedClient = client;
        } else {
          this.selectedClient = this.clientList[0];
        }
        //this.loadClientAutoFill(this.selectedClient.TDOCID);
      }
    });
  }

  ngAfterViewInit(): void {
    if (!this.staticDataService.isReady) {
      this.staticDataService.validValuesReadyEvent.subscribe({
        complete: () => {
          this.loadEnums();
          this.isLoading = false;
        }
      });
    } else {
      this.loadEnums();
      this.isLoading = false;
    }
  }

  loadEnums() {
    this.nextAppointmentEnums = this.staticDataService.getValidValueItemsByValidValueName('enumNextAppt');
    this.nextAppointmentLengthEnums = this.staticDataService.getValidValueItemsByValidValueName('enumNextApptLength');
    this.nextAppointmentDateEnums = this.staticDataService.getValidValueItemsByValidValueName('enumNextApptWhen');

  }

  refreshNotesToFrontAutoFillData(items: NotesToFrontAutoFill[] = null) {

    const ivl = setInterval(() => {
      if (!this.autoFillAppointment) {
        return;
      }
      clearInterval(ivl);
      if (items) {
        this.autoFillAppointment.updateData(items);
      } else {
        this.autoFillAppointment.updateData(this.autoFillList);
      }
    }, 10);
  }

  refreshNotesToFrontAutoFillDetailData(items: NotesToFrontAutoFillDetail[] = null) {
    const ivl = setInterval(() => {
      if (!this.autoFillAppointmentDetail) {
        return;
      }
      clearInterval(ivl);
      if (items) {
        this.autoFillAppointmentDetail.updateData(items);
      } else {
        if (this.selectedAutoFillModel)
          this.autoFillAppointmentDetail.updateData(this.selectedAutoFillModel.cfgNoteToFrontAutoFillDetails);
      }
    }, 10);
  }

  refreshSelectedOperatories() {
    const ivl = setInterval(() => {
      if (!this.autoFillAppointmentOperatories) {
        return;
      }
      clearInterval(ivl);
      if (this.selectedAutoFillDetailModel)
        this.autoFillAppointmentOperatories.updateData(this.selectedAutoFillDetailModel.cfgNoteToFrontAutoFillDetailOperatories);
    }, 10);
  }


  refreshAvailableOperatories() {
    const ivl = setInterval(() => {
      if (!this.availableLocationOperatories) {
        return;
      }
      clearInterval(ivl);
      this.availableLocationOperatories.updateData();
    }, 10);
  }

  refreshNotesToFrontAutoFillDetailOperatoriesData(items: OperatoryDataModel[] = null) {
    const ivl = setInterval(() => {
      if (!this.selectedAutoFillDetailModel) {
        return;
      }
      clearInterval(ivl);
      if (items) {

        this.autoFillAppointmentOperatories.updateData(items);
      } else {
        if (this.selectedAutoFillDetailModel)
          this.autoFillAppointmentOperatories.updateData(this.selectedAutoFillDetailModel.cfgNoteToFrontAutoFillDetailOperatories);
      }
    }, 10);
  }

  onAutoFillSelected(event: TdoTableSelectionEvent) {
    if (event.row?.model)
      this.selectedAutoFillModel = event.row.model as NotesToFrontAutoFill;
    else if (event.model)
      this.selectedAutoFillModel = event.model as NotesToFrontAutoFill;

    if (this.selectedAutoFillModel.cfgNoteToFrontAutoFillDetails.length > 0)
      this.selectedAutoFillDetailModel = this.selectedAutoFillModel.cfgNoteToFrontAutoFillDetails[0];
    else
      this.selectedAutoFillDetailModel = null;
    this.locationSelector?.selected.setValue([]);
    this.onLocationSelectionChange(null);
    this.refreshNotesToFrontAutoFillDetailData();
    this.refreshSelectedOperatories();
    this.refreshAvailableOperatories();
  }

  onAutoFillDetailSelected(event: TdoTableSelectionEvent) {
    if (event.row?.model)
      this.selectedAutoFillDetailModel = event.row.model as NotesToFrontAutoFillDetail;
    else if (event.model)
      this.selectedAutoFillDetailModel = event.model as NotesToFrontAutoFillDetail;

    this.locationSelector?.selected.setValue([]);
    this.onLocationSelectionChange(null);
    this.refreshSelectedOperatories();
    this.refreshAvailableOperatories();
  }

  onNewAutoFillAppointment() {

    const model = new NotesToFrontAutoFillDetail();
    model.AutoFillID = this.selectedAutoFillModel.AutoFillID;
    model.cfgNoteToFrontAutoFillDetailOperatories = [];

    this.selectedAutoFillModel.cfgNoteToFrontAutoFillDetails.push(model);
    this.selectedAutoFillDetailModel = model;
    this.refreshNotesToFrontAutoFillDetailData();
    this.refreshNotesToFrontAutoFillDetailOperatoriesData();

  }

  onNewAutoFill() {

    const model = new NotesToFrontAutoFill();
    model.TDOCID = this.selectedClient.TDOCID;
    model.Name = "# New AutoFill";
    model.cfgNoteToFrontAutoFillDetails = [];

    this.autoFillList.unshift(model);
    this.refreshNotesToFrontAutoFillData();
    this.selectedAutoFillModel = model;

    this.refreshNotesToFrontAutoFillDetailData();
    this.refreshSelectedOperatories();
    this.refreshAvailableOperatories();

  }

  private showErrorMessage(message: string) {
    this.snackBar.open(message, 'Error', {
      duration: 3000,
      verticalPosition: 'top'
    });
  }

  saveNotesToFrontAutoFill() {
    this.isLoading = true;
    this.autoFillList.forEach((item, index) => {
      if (this.isValidAppointmentAutoFill(item))
        this.saveAutoFillAppointmentItem(item, index);
      else
        this.showErrorMessage("Invald data in entry " + item.Name);
    });
    this.refreshNotesToFrontAutoFillData();
    this.refreshNotesToFrontAutoFillDetailData();
    this.configurationService.setClean();
    this.isLoading = false;
  }

  saveAutoFillAppointmentItem(item: NotesToFrontAutoFill, index: number) {
    this.notesToFrontService.saveNotesAutoFillConfigurationItem(item)
      .subscribe((ret) => {
        this.autoFillList[index] = ret;
      });
  }

  onDeleteAppointmentAutoFill(model: NotesToFrontAutoFill) {
    this.dialogService.openConfirmDialog('Are you sure you want to delete this item?').subscribe((res1) => {
      if (res1) {
        this.notesToFrontService.deleteNotesAutoFillConfigurationItem(model).subscribe(res => {
          const idx = this.autoFillList.findIndex(p => p.AutoFillID === model.AutoFillID);
          if (idx > -1) {
            this.autoFillList.splice(idx, 1);
            this.refreshNotesToFrontAutoFillData();
          }
        });
      }
    });
  }

  isValidAppointmentAutoFill(model: NotesToFrontAutoFill) {
    const isValidModel: boolean = (
      model.Name
      && model.ApptCount
      && model.cfgNoteToFrontAutoFillDetails.every(d =>
        d.AutoFillOrder
        && d.Name
        && d.enumNextApptID
        && d.enumNextApptLengthID
        && d.enumNextApptWhenID
      )
    );
    return isValidModel == true;

  }


  onDeleteAutoFillAppointmentDetail(model: NotesToFrontAutoFillDetail) {
    this.dialogService.openConfirmDialog('Are you sure you want to delete this item?').subscribe((res1) => {
      if (res1) {
        const idx = this.selectedAutoFillModel.cfgNoteToFrontAutoFillDetails.findIndex(p => p.AutoFillDetailID === model.AutoFillDetailID);
        if (idx > -1) {
          this.selectedAutoFillModel.cfgNoteToFrontAutoFillDetails.splice(idx, 1);
          if (this.selectedAutoFillModel.cfgNoteToFrontAutoFillDetails.length > 0)
            this.selectedAutoFillDetailModel = this.selectedAutoFillModel.cfgNoteToFrontAutoFillDetails[0];
          else
            this.selectedAutoFillDetailModel = null;
          const idAutoFill = this.autoFillList.findIndex(af => af.AutoFillID == this.selectedAutoFillModel.AutoFillID);
          this.autoFillList[idAutoFill] = this.selectedAutoFillModel;
          this.refreshNotesToFrontAutoFillDetailData();
          this.refreshNotesToFrontAutoFillDetailOperatoriesData();
          this.refreshAvailableOperatories();
          this.configurationService.setDirty();
        }
      }
    });
  }

  onChangeClient(event) {

    const l = this.configurationService.checkIsDirty();
    if (l) {
      l.subscribe((res) => {

        if (res) {
          this.changeClient(event.value);
          return;
        }
      });
    }
    else
      this.changeClient(event.value);
  }

  changeClient(client: TdoClientConfigurationModel) {
    this.isLoading = true;
    this.selectedClient = client;
    this.loadClientAutoFill(this.selectedClient.TDOCID);
    if (this.selectedLocation) {
      this.opsService.getLocationOperatories(this.selectedLocation?.LOCID.toString()).subscribe((ops) => {

        this.locationOperatories = ops;
        this.availableOperatories = this.locationOperatories;

        this.refreshSelectedOperatories();
        this.refreshAvailableOperatories();
      });
    }
    else {
      this.selectedLocation = null;
      this.locationSelector?.selected.setValue([]);
      this.locationOperatories = [];
      this.availableOperatories = this.locationOperatories;

      this.refreshSelectedOperatories();
      this.refreshAvailableOperatories();
    }
    this.isLoading = false;
  }

  loadClientAutoFill(TDOCID: string) {

    this.notesToFrontService.getNotesToFrontAutofillModels(TDOCID).subscribe((config) => {
      this.autoFillList = config;
      this.selectedAutoFillModel = this.autoFillList[0];
      this.refreshNotesToFrontAutoFillData();
      this.refreshNotesToFrontAutoFillDetailData(this.selectedAutoFillModel?.cfgNoteToFrontAutoFillDetails);

    });

    this.locService.getClientLocations(TDOCID).subscribe((ldata) => {
      this.locations = ldata;

      if (this.locations.length > 0) {
        const loc = this.locations.find(p => p.LOCID.toString() === this.globals.LOCID);
        if (loc) {
          this.selectedLocation = loc;
        } else {
          this.selectedLocation = this.locations[0];
        }
      }
    }, err => {
      console.log(err);
    });
  }

  getOperatoryName(opId: string) {

    const op = this.locationOperatories.find(op => op.OperatoryId == opId)
    const loc = this.locations.find(loc => loc.LOCID == op.LOCID);
    return loc.LocationShortName + ' ' + op.OperatoryName;
  }

  onOperatoryAdd(opId: string) {

    
    console.log("Adding this.selectedAutoFillDetailModel", this.selectedAutoFillDetailModel);

    const op = this.availableOperatories.find(op => op.OperatoryId == opId);
    const newOp: CfgNoteToFrontAutoFillDetailOperatories = {
      ...op,
      OperatoryName: this.getOperatoryName(opId),
      AutoFillDetailID: this.selectedAutoFillDetailModel.AutoFillDetailID,
      OperatoryId: op.OperatoryId,
      AutoFillDetailOpID: null
    };

    console.log("Adding op", newOp);
    this.selectedAutoFillDetailModel.cfgNoteToFrontAutoFillDetailOperatories.push(newOp);
    this.availableOperatories = this.locationOperatories.filter((op) => {
      return this.selectedAutoFillDetailModel.cfgNoteToFrontAutoFillDetailOperatories.find(s => s.OperatoryId == op.OperatoryId) == null;
    });

    this.refreshSelectedOperatories();
    this.refreshAvailableOperatories();
  }

  onOperatoryRemove(opId: string) {
    this.selectedAutoFillDetailModel.cfgNoteToFrontAutoFillDetailOperatories.splice(this.selectedAutoFillDetailModel.cfgNoteToFrontAutoFillDetailOperatories.findIndex(o => o.OperatoryId == opId), 1);
    this.availableOperatories = this.locationOperatories.filter((op) => {
      return this.selectedAutoFillDetailModel.cfgNoteToFrontAutoFillDetailOperatories.find(s => s.OperatoryId == op.OperatoryId) == null;
    });
    const idAutoFillDetail = this.selectedAutoFillModel.cfgNoteToFrontAutoFillDetails.findIndex(d => d.AutoFillDetailID == this.selectedAutoFillDetailModel.AutoFillDetailID);
    this.selectedAutoFillModel.cfgNoteToFrontAutoFillDetails[idAutoFillDetail] = this.selectedAutoFillDetailModel;
    const idAutoFill = this.autoFillList.findIndex(af => af.AutoFillID == this.selectedAutoFillModel.AutoFillID);
    this.autoFillList[idAutoFill] = this.selectedAutoFillModel;
    this.refreshSelectedOperatories();
    this.refreshAvailableOperatories();
  }

  onLocationSelectionChange(event: TdoDropdownChange) {

    if (event?.value != null) {
      this.selectedLocation = event.value as ClientLocationDataModel;

      this.opsService.getLocationOperatories(this.selectedLocation.LOCID.toString()).subscribe((ops) => {

        this.locationOperatories = ops;

        this.availableOperatories = this.locationOperatories.filter((op) => {
          return this.selectedAutoFillDetailModel.cfgNoteToFrontAutoFillDetailOperatories.find(s => s.OperatoryId == op.OperatoryId) == null;
        });

        this.refreshAvailableOperatories();

      },
        error => {
          console.log("onLocationSelectionChange error", error);
        },
      );
    }
    else {

      this.locationOperatories = [];
      this.availableOperatories = [];
      this.refreshAvailableOperatories();
    }
  }

  SetDefaultAppointmentDetail() {
    if (this.selectedAutoFillModel.isDefault) {
      this.autoFillList.forEach((item, index) => {
        if (item.AutoFillID != this.selectedAutoFillModel.AutoFillID)
          item.isDefault = false;
      });
    }
    this.configurationService.setDirty();
  }
}
